import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getEditorialByIdQuery, getEditorialsQuery } from '../../queries/editorial';

import type { Match, Player } from '@shared-types/match.types';
import { IS_TEST, language } from '@utilities/browser';

export const useArticle = (match: Match, player: Player, interval: number) => {
  const articleFilters = useMemo(
    () => ({
      type: 'article',
      'param.attributes.main.kind': 'Player of the Match',
      'param.attributes.footballEntities.match.matchId': match?.id,
      'param.attributes.footballEntities.player.playerId': player?.id,
      'param.attributes.language': language,
      aggregator: 'lightnodejson',
    }),
    [match?.id, player?.id],
  );

  const { data: articles } = useQuery({
    ...getEditorialsQuery(articleFilters),
    refetchInterval: !IS_TEST && interval,
    enabled: !!match?.id && !!player?.id,
  });

  const articleId = articles?.[0]?.id;

  const { data: article } = useQuery({
    ...getEditorialByIdQuery(articleId),
    refetchInterval: !IS_TEST && interval,
    enabled: !!articleId,
  });

  return article;
};
